import { getPackageHref } from "app/common/hrefs";

export const getPackageHrefWithPromoCode = (promoCode?: string, annualPromoCodes?: Set<string>) => {
    const packageHref = getPackageHref();
    if (!promoCode) {
        return packageHref;
    }

    const appendUpgradeToAnnual = annualPromoCodes?.has(promoCode);

    return `${packageHref}?promo=${promoCode}${appendUpgradeToAnnual ? "&withUpgradeToAnnual=true" : ""}`;
};
